import { render, staticRenderFns } from "./ColorPalette.vue?vue&type=template&id=41ec546b&scoped=true&"
import script from "./ColorPalette.vue?vue&type=script&lang=js&"
export * from "./ColorPalette.vue?vue&type=script&lang=js&"
import style0 from "./ColorPalette.vue?vue&type=style&index=0&id=41ec546b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ec546b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VCardSubtitle,VChip})
